<template>
    <div>
        <div  class="container">
        <embed src="https://maipdf.cn/file/at6892ecdf2ce15/pdf" type="application/pdf" width="100%" height="800px" />
    </div>
    <!-- 底部 -->
    <foot/>
    </div>
</template>
<script>
export default {

}
</script>
<style lang="scss" scoped>
.d-flex {
    display: flex;
}

.a-center {
    align-items: center;
}

.j-sb {
    justify-content: space-between;
}

.j-center {
    justify-content: center;
}

.container {
    width: 1000px;
    margin: 0 auto;

    .title {
        font-size: 28px;
        font-weight: 600;
        color: #333;
        margin-bottom: 30px !important;
    }
}
</style>